import React, { Component } from 'react'
/* eslint import/no-webpack-loader-syntax: off */
import bootstrapCSS from '!css-loader!bootstrap/dist/css/bootstrap.min.css'
import normalizeCSS from  '!css-loader!../styles/normalize.css'
import skeletonCSS from '!css-loader!../styles/skeleton.css'
import indexCSS from '!css-loader!../styles/index.css'

export class Styles extends Component {
    render() {
        return (
            <>
                <style type="text/css">{bootstrapCSS.toString()}</style>
                <style type="text/css">{normalizeCSS.toString()}</style>
                <style type="text/css">{skeletonCSS.toString()}</style>
                <style type="text/css">{indexCSS.toString()}</style>
            </>
        )
    }
}